import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <h3 className="text-white text-lg font-bold mb-4">Tahaa Lagoon Kayak</h3>
          <p className="text-sm leading-relaxed mb-4">
            Explorez le lagon de Tahaa à votre rythme. Location de kayaks tout confort pour une aventure autonome inoubliable au cœur de la Polynésie.
          </p>
          {/* LOGOS SOCIAUX EN COULEURS RÉELLES */}
          <div className="flex space-x-6 items-center">
            <a 
              href="https://www.instagram.com/tahaalagoon/" 
              target="_blank" 
              rel="noreferrer" 
              className="transition-transform hover:scale-110"
            >
              <img src="/images/insta-logo.png" alt="Suivez Tahaa Lagoon Kayak sur Instagram" className="w-7 h-7 object-contain" />
            </a>
            <a 
              href="https://www.facebook.com/profile.php?id=61553948141339" 
              target="_blank" 
              rel="noreferrer" 
              className="transition-transform hover:scale-110"
            >
              <img src="/images/fb-logo.png" alt="Suivez Tahaa Lagoon Kayak sur Facebook" className="w-7 h-7 object-contain" />
            </a>
          </div>
        </div>
        <div>
          <h3 className="text-white text-lg font-bold mb-4">Liens Rapides</h3>
          <ul className="space-y-2 text-sm">
             <li><Link to="/location-de-kayak/" className="hover:text-cyan-400">Réserver un Kayak</Link></li>
             <li><Link to="/materiels-equipements/" className="hover:text-cyan-400">Matériels & Équipements</Link></li>
             <li><a href="https://tahaa-excursions.com" target="_blank" rel="noreferrer" className="hover:text-cyan-400">Excursions Bateau Privées</a></li>
             <li><Link to="/formulaire-de-contact/" className="hover:text-cyan-400">Nous Contacter</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="text-white text-lg font-bold mb-4">Contact</h3>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-3"><Phone size={16} className="text-cyan-400"/> +689 87 33 57 13</li>
            <li className="flex items-center gap-3"><Mail size={16} className="text-cyan-400"/> contact@tahaaepaddleadventure.com</li>
            <li className="flex items-start gap-3"><MapPin size={16} className="text-cyan-400 mt-1"/> Murifenua, Tapuamu, Tahaa</li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-8 border-t border-slate-800 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Tahaa Lagoon Kayak. Tous droits réservés.
      </div>
    </footer>
  );
};

export default Footer;